export default __webpack_public_path__ + "static/media/logo_ndvy.c3eb1cf7.png";